<template>
  <div class="editor_wrap">
    <div class="title_wrap">
      <div v-for="item in items" :key="item.id" @click="change(item.id)" :class="{ 'border-red': index === item.id }">{{ item.title }}</div>
      <div><nuxt-link to="/user/article/deliver" target="_blank" rel="noopener">发表文章</nuxt-link></div>
    </div>
    <div>
      <component :is="currentView"></component>
    </div>
  </div>
</template>

<script>
import EditView from '@/components/room/TeacherEditView'

export default {
  name: 'component-room-editor-warp',
  data () {
    return {
    	index: 'EditView',
      currentView: EditView,
      // 老师权限列表， 邀请嘉宾没有权限 3、5
      items: [
        { id: 'EditView', title: '发表观点' },
        { id: 'ViewSet', title: '修改直播设置' },
        { id: 'NormalView', title: '常用观点设置' },
        { id: 'NoSpeech', title: '禁言用户管理' },
        { id: 'AddtoCjgSet', title: '追加藏金阁' }
      ]
    }
  },
  created () {
    if (!this.$store.getters['room/isTeacher']) {
      // 邀请嘉宾需要删除某些权限列表
      this.items.splice(3, 1)
    }
  },
  methods: {
    change (id) {
      this.index = id
      this.currentView = () => import(`@/components/room/Teacher${id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.editor_wrap { 
  height: 361px; background: #ededed;
  .title_wrap { 
    height: 42px;  border-top: 1px solid #c6c6c6; border-bottom: 1px solid #c6c6c6;
    div { 
      float: left; height: 100%; line-height: 42px; padding: 0 24px; cursor: pointer; border-bottom: 2px solid #ededed; font-size: 14px;
    	a { font-size: 14px; color: #000; }
    	&:hover,&:hover > a { color: #EA6E52;}
    }
  }
}
</style>
